module.exports = __webpack_public_path__ + "img/load.16741a79.gif";